<div class="min-h-screen flex flex-col">
  <!-- Header -->
  <header class="w-full border-b border-gray-200">
    <div class="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3" *ngIf="current$ | async as current; else noSelection">
      <span class="pi pi-star-fill text-brand-600 text-xl" aria-hidden="true"></span>
      <div class="font-medium text-gray-800">
        {{ 'header.title' | translate }}
      </div>
    </div>
    <ng-template #noSelection>
      <div class="max-w-5xl mx-auto px-6 py-4 flex items-center gap-3">
        <span class="pi pi-star-fill text-brand-600 text-xl" aria-hidden="true"></span>
        <div class="font-medium text-gray-800">{{ 'header.title' | translate }}</div>
      </div>
    </ng-template>
  </header>

  <!-- Main content -->
  <main class="flex-1">
    <div class="max-w-6xl mx-auto px-6 py-14 text-center">
      <h1 class="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight text-gray-900">
        {{ 'home.welcomeLine1' | translate }}
        <br />
        {{ 'home.welcomeLine2' | translate }}
      </h1>
      <p class="mt-6 text-lg text-gray-600">
        {{ 'home.subtitle' | translate }}
      </p>

      <!-- Municipality selector -->
      <div class="mt-12">
        <div class="text-sm uppercase tracking-wide text-gray-500 mb-4">{{ 'home.selectMunicipality' | translate }}</div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div
            *ngFor="let m of municipalities"
            class="bg-white rounded-2xl shadow-sm border border-gray-200 hover:shadow-md transition overflow-hidden"
          >
            <div class="h-40 w-full bg-gray-100">
              <img [src]="m.imageUrl" alt="" class="w-full h-full object-cover" />
            </div>
            <div class="p-6">
              <div class="font-semibold text-gray-900 text-lg">{{ 'municipalities.' + m.id | translate }}</div>
              <!--              <div class="mt-4">-->
              <!--                <div class="w-full bg-zinc-100 text-gray-800 px-4 py-3 rounded-lg">-->
              <!--                  {{ 'home.municipalServices' | translate }}-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="mt-4 text-sm uppercase tracking-wide text-gray-500">
                {{ 'home.municipalServices' | translate }}
              </div>
              <div class="mt-4 flex flex-col gap-4" *ngIf="m.comuni?.length">
                <button
                  *ngFor="let comune of m.comuni"
                  pButton
                  type="button"
                  class="w-full bg-brand-600 hover:bg-brand-700 text-white px-4 py-4 rounded-lg text-base"
                  [label]="'municipalities.' + comune.id | translate"
                  (click)="selectMunicipality(comune.id)"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="w-full mt-auto py-10 text-gray-600">
    <div class="max-w-4xl mx-auto px-6">
      <div class="flex justify-center gap-10 text-sm">
        <!--        <div class="flex items-center gap-2">-->
        <!--          <span class="pi pi-universal-access text-gray-500"></span>-->
        <!--          <span>{{ 'footer.accessibility' | translate }}</span>-->
        <!--        </div>-->
        <div class="flex items-center gap-2">
          <span class="pi pi-globe text-gray-500"></span>
          <span>{{ 'footer.language' | translate }}</span>
          <div class="inline-flex rounded-md overflow-hidden border border-gray-300 ml-2">
            <button (click)="switchLanguage('en')" class="px-2 py-1 hover:bg-gray-100">EN</button>
            <button (click)="switchLanguage('it')" class="px-2 py-1 hover:bg-gray-100">IT</button>
          </div>
        </div>
      </div>
      <p class="text-center text-xs mt-6">&copy; 2025 Sigmasoft. {{ 'footer.rights' | translate }}</p>
    </div>
  </footer>
</div>
